import { useQuery } from '@tanstack/react-query';
import { getClientProductList, getProductList } from '../api/productsApi';
import { Product } from '../api/productsApi/interfaces';

export const useGetproductsList = (enabled: boolean = true) => {
  return useQuery<Product[]>({
    queryFn: () => getProductList(),
    queryKey: ['product-list'],
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    enabled,
  });
};

export const useGetClientProductsList = (
  clientId: number | undefined,
  enabled: boolean = true
) => {
  return useQuery<Product[]>({
    queryFn: () => getClientProductList(clientId || 0),
    queryKey: ['client-products-list', clientId],
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    enabled: enabled && clientId !== undefined,
  });
};
